
import { CreatomateFont, BuiltInFontDefinition } from "./BuiltInFonts";

export const CreatomateZendeskFonts: CreatomateFont[] = [
  {
    family: "FeatureText-Bold-Web",
    weight: 700,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/FeatureText-Bold-Web.ttf"
  },
  {
    family: "FeatureText-Extrabold-Web",
    weight: 700,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/FeatureText-Extrabold-Web.ttf"
  },
  {
    family: "FeatureText-BoldItalic-Web",
    weight: 700,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/FeatureText-BoldItalic-Web.ttf"
  },
  {
    family: "FeatureText-Regular-Web",
    weight: 400,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/FeatureText-Regular-Web.ttf"
  },
  {
    family: "FeatureText-ExtraboldItalic-Web",
    weight: 800,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/FeatureText-ExtraboldItalic-Web.ttf"
  },
  {
    family: "FeatureDisplay-Medium-Web",
    weight: 500,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/FeatureDisplay-Medium-Web.ttf"
  }
];

export const BuiltInZendeskFonts: BuiltInFontDefinition[] = [
  {
    family: "FeatureText-Bold-Web",
    weights: [700],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/FeatureText-Bold-Web.ttf"
  },
  {
    family: "FeatureText-Extrabold-Web",
    weights: [700],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/FeatureText-Extrabold-Web.ttf"
  },
  {
    family: "FeatureText-BoldItalic-Web",
    weights: [700],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/FeatureText-BoldItalic-Web.ttf"
  },
  {
    family: "FeatureText-Regular-Web",
    weights: [400],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/FeatureText-Regular-Web.ttf"
  },
  {
    family: "FeatureText-ExtraboldItalic-Web",
    weights: [800],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/FeatureText-ExtraboldItalic-Web.ttf"
  },
  {
    family: "FeatureDisplay-Medium-Web",
    weights: [500],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/FeatureDisplay-Medium-Web.ttf"
  }
];
